const collapsibles = document.querySelectorAll(
  '[data-js-target="collapsible"]'
);

collapsibles.forEach((collapsible) => {
  const button = collapsible.querySelector(
    '[data-js-target="collapsible__toggle"]'
  );
  const content = collapsible.querySelector(
    '[data-js-target="collapsible__content"]'
  );

  button.addEventListener("click", () => {
    const isExpanded = button.getAttribute("aria-expanded") === "true";

    button.setAttribute("aria-expanded", !isExpanded);
    button.classList.toggle("collapsed", !isExpanded);

    if (!isExpanded) {
      content.style.maxHeight = content.scrollHeight + "px";
    } else {
      content.style.maxHeight = "0";
    }
  });
});
